import { gql } from 'apollo-angular';
import { secondFactorMinimalFragment, securityQuestionMinimalFragment } from '../minimal.fragments';

export const ResetSecondFactorMutation = gql`
  mutation resetSecondFactor($input: ResetSecondFactorInput!) {
    resetSecondFactor(input: $input) {
      otpSecret
      errors {
        path
        message
      }
    }
  }
`;

export const EnableSecondFactorMutation = gql`
  mutation enableSecondFactor($input: EnableSecondFactorInput!) {
    enableSecondFactor(input: $input) {
      errors {
        path
        message
      }

      secondFactor {
        ...SecondFactorMinimal
        securityKey
      }
    }
  }
  ${secondFactorMinimalFragment}
`;

export const DisableSecondFactorWithSecurityKeyMutation = gql`
  mutation disableSecondFactorWithSecurityKey($input: DisableSecondFactorWithSecurityKeyInput!) {
    disableSecondFactorWithSecurityKey(input: $input) {
      disabled
      errors {
        path
        message
      }
    }
  }
`;

export const CreateSecurityQuestionMutation = gql`
  mutation createSecurityQuestion($input: CreateSecurityQuestionInput!) {
    createSecurityQuestion(input: $input) {
      securityQuestion {
        ...SecurityQuestionMinimal
      }
      errors {
        path
        message
      }
    }
  }
  ${securityQuestionMinimalFragment}
`;

export const SendSecondFactorResetRequestMutation = gql`
  mutation sendSecondFactorResetRequest($input: SendSecondFactorResetRequestInput!) {
    sendSecondFactorResetRequest(input: $input) {
      emailsSent
      errors {
        path
        message
      }
    }
  }
`;

export const AdminDisableSecondFactorMutation = gql`
  mutation adminDisableSecondFactor($input: AdminDisableSecondFactorInput!) {
    adminDisableSecondFactor(input: $input) {
      secondFactor {
        ...SecondFactorMinimal
      }
      errors {
        path
        message
      }
    }
  }
  ${secondFactorMinimalFragment}
`;
